import { fetch } from '../fetchWrapper/fetch';
import { EXTENSIONS_API_URL } from '../../constants';
import { ICreateInstanceRequest, IExtensionInstance } from './types';

export const createInstance = async (
  brandId: string,
  extensionId: string,
  payload: ICreateInstanceRequest,
): Promise<IExtensionInstance> => {
  try {
    const res = await fetch(`${EXTENSIONS_API_URL}/${extensionId}/instances`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'brand-id': brandId,
      },
      body: JSON.stringify(payload),
    });
    if (res.status !== 200 && res.status !== 201) {
      const errorBody = await res.json().catch(() => ({}));
      throw new Error(errorBody.message || `Request failed with status ${res.status}`);
    }
    const json: { data: IExtensionInstance[] } = await res.json();
    if (!json.data?.[0]) {
      throw new Error('Invalid response: no instance data returned');
    }
    return json.data[0];
  } catch (e) {
    if (e instanceof Error) throw e;
    throw new Error('Could not create instance');
  }
};
